import React from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  Title
);

interface ComplianceDistributionChartProps {
  data: {
    labels: string[];
    values: number[];
  };
  title?: string;
  height?: number;
}

const ComplianceDistributionChart: React.FC<ComplianceDistributionChartProps> = ({
  data,
  title = 'Compliance Distribution',
  height = 350
}) => {
  const colors = [
    '#10b981', // green for compliant
    '#f59e0b', // yellow for partially compliant
    '#ef4444', // red for non-compliant
    '#6b7280'  // gray for under review
  ];

  const chartData = {
    labels: data.labels,
    datasets: [
      {
        data: data.values,
        backgroundColor: colors,
        borderColor: colors.map(color => color),
        borderWidth: 2,
        hoverOffset: 4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right' as const,
        labels: {
          padding: 20,
          usePointStyle: true
        }
      },
      title: {
        display: !!title,
        text: title,
        font: {
          size: 16,
          weight: 'bold' as const
        }
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            const label = context.label || '';
            const value = context.parsed;
            const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value}% (${percentage}%)`;
          }
        }
      }
    },
    cutout: '60%'
  };

  return (
    <div style={{ height: `${height}px`, display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        <Doughnut data={chartData} options={options} />
      </div>
    </div>
  );
};

export default ComplianceDistributionChart;